function getSymbol() {
    if ( $( "#currencyDrop, #booking_filters_currency_currency" ).length && currency_symbols != undefined ) {
        return $( "<div/>" ).html( currency_symbols[ $( "#currencyDrop, #booking_filters_currency_currency" ).val() ] ).text();
    }
    else {
        return "&pound;";
    }
}

function getSpanRateKey( currency, inc_or_ex ) {
    return key = 'rate_' + currency.toLowerCase() + (( 'Ex' == inc_or_ex ) ? '_ex' : '');
}

function getMinPrice( currency, inc_or_ex ) {
    var min_value = 9999999999;

    var key = getSpanRateKey( currency, inc_or_ex );

    $( '.currency-to-convert.price' ).each( function() {
        if ( $( this ).attr( key ) && parseFloat( $( this ).attr( key ) ) < min_value ) {
            min_value = parseFloat( $( this ).attr( key ) );
        }
    } );

    if ( min_value == 9999999999 ) {
        return 0;
    }
    else {
        return Math.floor( min_value / 10 ) * 10;
    }
}

function getMaxPrice() {
    var max_value = -1;

    var key = getSpanRateKey( currency, inc_or_ex );

    $( '.currency-to-convert.price' ).each( function() {
        if ( $( this ).attr( key ) && parseFloat( $( this ).attr( key ) ) > max_value ) {
            max_value = parseFloat( $( this ).attr( key ) );
        }
    } );

    if ( max_value == -1 ) {
        return 0;
    }
    else {
        return Math.ceil( max_value / 10 ) * 10;
    }
}

jQuery( document ).ready( function( $ ) {

    /* These elements are selected by id but on collections pages these are named differently and need to be selected by different id... */
    var $taxDrop = $( '#taxDrop' ), $currencyDrop = $( '#currencyDrop' );
    /* ...so, check if the ids are present, if not get by alternative ids */
    if( $taxDrop.length < 1 ) {
        $taxDrop = $( '#booking_filters_tax' );
    }
    if( $currencyDrop.length < 1 ) {
        $currencyDrop = $( '#booking_filters_currency_currency' );
    }
    $currencyDrop.on( 'change', function () {
        convert_currency( $( this ).val() );

        /*---- Slider ----*/
        /*
         currency = $('#currencyDrop').val();
         inc_or_ex = $taxDrop.val();

         min_price = getMinPrice(currency, inc_or_ex);
         max_price = getMaxPrice(currency, inc_or_ex);

         $(function() {
         $( "#price-slider" ).slider({
         range: true,
         min: min_price,
         max: max_price,
         step: (((max_price - min_price) / 100) * 10),
         values: [min_price, max_price],
         slide: function( event, ui ) {
         $( "#amount" ).val( getSymbol() + ui.values[ 0 ] + " - " + getSymbol() + ui.values[ 1 ] );
         },
         change: function(event, ui){
         doFiltering();
         }
         });
         $( "#amount" ).val( getSymbol() + add_commas($( "#price-slider" ).slider( "values", 0 )) +
         " - " + getSymbol() + add_commas($( "#price-slider" ).slider( "values", 1 )) );
         });
         */
        /*---- /Slider ----*/

        var url = $(this).attr('rel')
        var new_url = url.replace('GBP', $(this).val());
        if( $taxDrop.length ) {
            var new_url = new_url.replace('inc', $taxDrop.val().toLowerCase() );
        }
        $.ajax({url: new_url});
    });

    function add_commas( nStr ) {
        nStr += '';
        x = nStr.split( '.' );
        x1 = x[ 0 ];
        x2 = x.length > 1 ? '.' + x[ 1 ] : '';
        var rgx = /(\d+)(\d{3})/;
        while ( rgx.test( x1 ) ) {
            x1 = x1.replace( rgx, '$1' + ',' + '$2' );
        }
        return x1 + x2;
    };

    function convert_currency( type ) {

        $( '.currency-to-convert, .price, .pricetax' ).each( function() {
            var key = type;
            if ( $taxDrop.length ) {
                if ( 'Ex' == $taxDrop.val() ) {
                    key = type + '_ex';
                }
                else {
                    key = type;
                }
            }
            else if ( $( this ).hasClass( 'pricetax' ) ) {
                key = type + "_ex";
            }
            else {
                key = type;
            }
            key = key.toLowerCase();
            var converted = "" + add_commas( $( this ).attr( "rate_" + key ) );
            if ( $( this ).attr( 'symbol_' + type ) != undefined ) {
                converted = $( this ).attr( 'symbol_' + type ) + converted;
            }
            $( this ).html( converted );
        } );
    };

    $taxDrop.on( 'change', function() {
        $currencyDrop.trigger( 'change' );
        $( '.tax' ).each( function() {
            var tax;
            if ( $taxDrop.val() == 'Ex' ) {
                tax = "ex";
            }
            else {
                tax = "inc";
            }
            $( this ).html( tax );
        } );
    } );

    //$('#currencyDrop').trigger('change');
    $taxDrop.trigger( 'change' );


    /*---- /Currency Filtering ----*/

    /*---- Dropdown ----*/
    $( ".dropdown dt a" ).click( function() {
        $( ".dropdown dd ul" ).toggle();
    } );

    $( document ).bind( 'click', function( e ) {
        var $clicked = $( e.target );
        if ( !$clicked.parents().hasClass( "dropdown" ) ) {
            $( ".dropdown dd ul" ).hide();
        }
    } );

    $( ".dropdown dd ul li a" ).click( function() {
        var text = $( this ).html();
        $( ".dropdown dt a" ).html( text );
        $( ".dropdown dd ul" ).hide();

        var $source = $( "#source" );
        $source.val( $( this ).find( "span.value" ).html() )
    } );

    function createDropDown() {
        var $source = $currencyDrop;
        var selected = $source.find( "option[selected]" );  // get selected <option>
        var options = $( "option", $source );  // get all <option> elements
        // create <dl> and <dt> with selected value inside it
        $( "body" ).append( '<dl id="target" class="dropdown"></dl>' )
        $( "#target" ).append( '<dt><a href="#">' + selected.text() +
            '<span class="value">' + selected.val() +
            '</span></a></dt>' )
        $( "#target" ).append( '<dd><ul></ul></dd>' )
        // iterate through all the <option> elements and create UL
        options.each( function() {
            $( "#target dd ul" ).append( '<li><a href="#">' + $( this ).text() + '<span class="value">' + $( this ).val() + '</span></a></li>' );
        } );
    }

    /*---- Search filter on map ----*/
    $( "a.mapSlide" ).click( function( event ) {
        event.preventDefault();
        $( "#search_filter" ).toggle( 'slide', { direction: 'left' }, 1000 );
    } );

    // sticky floating bar
    if ( 0 < $( '#searchArea' ).length && !$( '#searchForm' ).hasClass( 'no-follow' ) ) {
        var top = $( '#searchArea' ).offset().top - parseFloat( $( '#searchArea' ).css( 'marginTop' ).replace( /auto/, 0 ) );
        $( window ).scroll( function( event ) {
            // what the y position of the scroll is
            var y = $( this ).scrollTop();

            // whether that's below the form
            if ( y >= top ) {
                // if so, ad the fixed class
                $( '#searchArea' ).addClass( 'fixed' );
            }
            else {
                // otherwise remove it
                $( '#searchArea' ).removeClass( 'fixed' );
            }
        } );
    }


    $( '#search-query' ).searchBoxFocus();

    $( '#feat-offers' ).equalHeights();


    $( '#trggr-promise' ).click( function() {
        $( "#modal-promise" ).modal( {
            overlayClose: true
        } );
        return false;
    } );

    $( '#feat-offers .more-lnk' ).eq( 1 ).click( function() {
        $( "#modal-join" ).modal( {
            overlayClose: true
        } );
        return false;
    } );

    //Find hotel form
    var $form = $( '#search-hotel' );
    $( '.field1 input', $form ).val( 'Hotel, house, region, country or destination' );
    $( '.field2', $form ).text( 'Arrival and departure' );

    $( '.main-feat-img' ).on('load', function() {
        $( this ).fadeIn( 'slow' );
    } );

    //remove tag on click
    $( '.filters li' ).click( function() {
        var $parentEl = $( this ).parents( 'ul' ),
            index = $( 'li', $parentEl ).index( this );

        $( '.filters' ).eq( 0 ).find( 'li' ).eq( index ).fadeOut( 'fast' ).remove();
        $( '.filters' ).eq( 1 ).find( 'li' ).eq( index ).fadeOut( 'fast' ).remove();
    } );


    //TEMP
    $( '#search-query' ).click( function() {
        $( '.predict-search' ).fadeToggle( 'fast' );
    } );

    //TEMP
    $( '.lnk-help' ).click( function() {
        $( "#modal-offer" ).modal( {
            overlayClose: true
        } );
        return false;
    } );

    $( 'a.moreLink' ).click( function( e ) {
        e.stopPropagation();
        $( 'div' ).animate( {
            'height': h
        } )
            .addClass( 'lessLink' )
            .removeClass( 'moreLink' )
    } );

    $( 'a.lessLink' ).click( function( e ) {
        e.stopPropagation();
        $( 'div' ).animate( {
            'height': -h
        } )
            .addClass( 'moreLink' )
            .removeClass( 'lessLink' )
    } );

    if ( $( '#homeHeroNote' ).length > 0 ) {
        $( '#homeHeroNote ol li' ).hide();
        var length = $( '#homeHeroNote ol li' ).length;
        var element = $( '#homeHeroNote ol li' )
        var current = 0;
        timeout = 3000;

        element.eq( current ).fadeIn( 300 );
        $( '#homeHeroNote ol' ).each( function() {
            $( this ).children().prepend( function( current ) {
                return '<span>' + (current + 1) + '. </span>';
            } );
        } );

        function changeSlide() {
            element.eq( current++ ).fadeOut( 300, function() {
                if ( current === length ) {
                    current = 0;
                }

                element.eq( current ).fadeIn( 300 );
            } );
            setTimeout( changeSlide, timeout );
        }

        setTimeout( changeSlide, timeout );
    }
} ); //end jQuery(document).ready(

// focus on search box
(function( $ ) {
    $.fn.searchBoxFocus = function() {
        return this.each( function() {
            var e = $( this );
            e.focus( function() {
                $( this ).css( { color: '#384244' } )
            } )
        } );
    };
})( jQuery );

//equal heights
(function( $ ) {
    $.fn.equalHeights = function( px ) {
        var currentTallest = 0;
        $( this ).each( function() {
            currentTallest = 0;
            $( this ).children().each( function( i ) {
                if ( $( this ).height() > currentTallest ) { currentTallest = $( this ).height(); }
            } );
            $( this ).children().css( { 'min-height': currentTallest } );

        } );
        return this;
    };
})( jQuery );

(function( $ ) {
    $.fn.triggerSelectMenus = function() {
        $( 'select.selectDropMenu:visible' ).each( function() {
            $( this ).selectmenu();
            $( this ).selectmenu( "widget" ).addClass( $( this ).attr( 'class' ) );
        } );

        $( 'div.selectDropMenu' ).each( function() {
            classes = $( this ).data( 'classes' );
            $( this ).find( 'select:visible' ).each( function() {
                $( this ).selectmenu();
                $( this ).selectmenu( "widget" ).addClass( classes );
            } );
        } );
    };
})( jQuery );
